export enum ExportType {
  SCHUKO_LEKO = 'SchuKo & LeKo',
  US_OS = 'Kinder & Jugendliche',
}
